import React from "react";
import ArtImage from "../../../images/rock_asst.png";
import Helmet from "../../../images/helmet.webp";
import "./style.scss";

const DigitalTreasures = () => {
  return (
    <section className="digital-treasure-section">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-[50%] p-4 py-12 relative">
          <img
            alt="ArtImage"
            src={ArtImage}
            className="absolute top-0 left-0 w-full h-full object-cover"
          />

          {/* <div className="helmet-icon">
            <img alt="Helmet" src={Helmet} className="h-auto w-full block" />
          </div> */}
        </div>
        <div className="lg:w-[50%] bg-black relative z-[1] overflow-hidden right-side-wrapper">
          <div className="text-stroke-bg">
            <h1 className="bg-text">Unique Assets</h1>
            <h1 className="bg-text">Unique Assets</h1>
          </div>
          <h4>
            Unique <br />
            Digital
            <br />
            <span>Treasures</span>
          </h4>
        </div>
      </div>
    </section>
  );
};

export default DigitalTreasures;
